import * as go from 'gojs';

export const getAvailableLocation = (diagram: go.Diagram): go.Point => {
  return new go.Point(diagram.documentBounds.centerX, diagram.documentBounds.centerY);
};
